import React from 'react';

export const CrashMessageFooter = () => <footer className="crash__footer" />;
